import React from 'react';
import { shapes } from '@cimpress/react-components';
import { Link } from 'react-router-dom';
import { FlexBox, JustifyContent } from '../../utils/css-classes';

const { CardHeader } = shapes;

// tslint:disable-next-line:variable-name
const HomePage = () => (
  <div>
    <div className="page-title">
      <div className="h1">
        Welcome to the Shipping Operations UI
      </div>
    </div>
    <div className={`${FlexBox.FLEX} ${JustifyContent.CENTER}`}>
      <div className="card-deck">
        <Link to="/sortation">
          <div className="card m-5">
            <div className="card-header">
              <CardHeader svgUrl="https://static.ux.cimpress.io/assets/icons/box-3-l.svg" />
            </div>
            <div className={`card-block ${FlexBox.FLEX} ${JustifyContent.CENTER}`}>
              Shipments
            </div>
          </div>
        </Link>
        <Link to="/manifests">
          <div className="card m-5">
            <div className="card-header">
              <CardHeader svgUrl="https://static.ux.cimpress.io/assets/icons/truck-configure-l.svg" />
            </div>
            <div className={`card-block ${FlexBox.FLEX} ${JustifyContent.CENTER}`}>
              Manifests
            </div>
          </div>
        </Link>
      </div>
    </div>
  </div>
);

export default HomePage;
